import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";
import {Vacation} from '../../admin/models/vacation.model';
import {ManagerService} from '../manager.service';

@Component({
    selector: 'app-work-abroad-pop-up',
    templateUrl: './all-request-pop-up.component.html',
    styleUrls: ['./all-request-pop-up.component.scss']
})
export class AllRequestPopUpComponent implements OnInit {

    public dataSource: MatTableDataSource<Vacation> = new MatTableDataSource<Vacation>([]);
    public fieldNames = [''];
    public displayNames = [''];
    public getDisplayValue = new Map<string, string>();
    public counter = 0;
    public pendingDays = 0;
    public allValue: any[] = [];

    constructor(public dialogRef: MatDialogRef<[]>,
                private readonly managerService: ManagerService,
                @Inject(MAT_DIALOG_DATA) public selectedData: any) {
    }

    ngOnInit(): void {
        if (this.selectedData[2] == 'vacation') {
            this.vacation();
            this.calculateDisplayValueVacation();
            this.fieldNames = ['dateCreated', 'startDate', 'endDate', 'halfDay', 'numberOfAnnualLeaveDays', 'requestStatus',
                'absenceType', 'absenceReason'];
            this.displayNames = ['Date Created', 'Start Date', 'End Date', 'Half Date', 'Total Absence', 'Approval status',
                'Absence Type', 'Absence Reason'];
        } else {
            this.workAbroad();
            this.calculateDisplayValueWork();
            this.fieldNames = ['country', 'dateCreated', 'startDate', 'endDate', 'numberOfAnnualLeaveDays', 'numberOfWorkAbroadDays',
                'requestStatus'];
            this.displayNames = ['Country', 'Date Created', 'Start Date', 'End Date', 'Annual Leave Length', 'Work Abroad Length',
                'Approval Status'];
        }
        this.updateStartEndDateFormat();
    }

    public vacation() {
        this.allValue = [];
        this.counter = 0;
        this.pendingDays = 0;
        this.selectedData[0].forEach((val: any) => {
            val.pendingVacation.forEach((value: any) => {
                if (this.selectedData[1].gmin == value.gmin && this.selectedData[1].year == value.year) {
                    this.allValue.push(value)
                    if (value.requestStatus == "PENDING") {
                        this.counter++;
                        this.pendingDays += Number(value.numberOfAnnualLeaveDays);
                    }
                }
            });
        });
        this.dataSource.data = this.allValue;
    }

    /**.
     * Convert date as a string into an ISO string to sort correctly
     */
    updateStartEndDateFormat() {
        for (const element of this.dataSource.data) {
            if (element.startDate.includes('/')) {
                const startDate = element.startDate;
                const endDate = element.endDate;
                const [day, month, year] = startDate.split('/');
                const [dayEnd, monthEnd, yearEnd] = endDate.split('/');
                element.startDate = new Date(+year, +month - 1, +day).toISOString();
                element.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
            }
        }
    }

    public workAbroad() {
        this.allValue = [];
        this.counter = 0;
        this.pendingDays = 0;
        this.selectedData[0].forEach((dat: any) => {
            dat.pendingWork.forEach((data: any) => {
                if (this.selectedData[1].gmin == data.gmin) {
                    this.allValue.push(data)
                    if (data.requestStatus == "PENDING") {
                        this.counter++;
                        this.pendingDays += Number(data.numberOfWorkAbroadDays);
                    }
                }
            });
        });
        this.dataSource.data = this.allValue;
    }

    /**
     * Calculates the remaining and leave entitlement for vacation to be used in Mat-Cards.
     * */
    public calculateDisplayValueVacation() {
        this.getDisplayValue.set('pendingDays', String(this.pendingDays));
        this.getDisplayValue.set('pendingRequests', String(this.counter));
        this.getDisplayValue.set('remainingDays', (this.selectedData[1].vacationAllowanceRemaining));
        this.getDisplayValue.set('leaveEntitlement', (this.selectedData[1].vacationAllowance + this.selectedData[1].vacationAllowanceCarryover));
    }

    /**
     * Calculates the remaining and leave entitlement for Work Abroad to be used in Mat-Cards.
     * */
    public calculateDisplayValueWork() {
        this.getDisplayValue.set('pendingRequests', String(this.counter));
        this.getDisplayValue.set('pendingDays', String(this.pendingDays));
        this.getDisplayValue.set('remainingDays', this.selectedData[1].allowanceRemaining);
        this.getDisplayValue.set('leaveEntitlement', this.selectedData[1].allowance);
    }

    /**
     * Calls a service method to get a string representing a boolean value
     * @param bool The boolean value to check
     */
    public halfDayStatus(bool: boolean): string {
        return this.managerService.halfDayStatus(bool);
    }
}
